module.exports = ".truncate-cell {\n    max-width: 250px; /* feel free to include any other value */\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = ./src/app/home/home.component.css
// module chunks = main